<template>
	<div class="drawer">
		<el-drawer
		size="33%"
		title="绑定礼品卡"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<el-row style="padding:0px 20px 0;float: none;font-size: 20px;">
				<el-col>
					<el-form :inline="true"  @submit.native.prevent>
						<el-form-item >
							<label style="font-size: 12px;" slot="label" >录入礼品卡号</label>
							<el-input style="width:280px;" v-model="scanningCode" @keyup.enter.native="searchScanningCode" placeholder="请录入礼品卡号" size="small"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<el-row>
				<el-col>
					<div class="tableTit">条码信息</div>
				</el-col>
			</el-row>
			<el-form :inline="true" class="form">
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="名称:" :label-width="formLabelWidth">
								<span class="value">{{msg.card_name}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="类型:" :label-width="formLabelWidth">
								<span class="value">{{msg.card_type&&msg.card_type.title}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="条码:" :label-width="formLabelWidth">
								<span class="value">{{msg.card_number}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="面额:" :label-width="formLabelWidth">
								<span class="value">{{msg.price}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="剩余金额:" :label-width="formLabelWidth">
								<span class="value">{{msg.surplus_money}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="状态:" :label-width="formLabelWidth">
								<span class="value">{{msg.sale_state&&msg.sale_state.title}}</span>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-button type="warning" style="width:80%;margin: 100px 10%;" @click="bind">绑定</el-button>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'100px',
				scanningCode:'',
				msg:{},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			searchScanningCode(){
				this.getGoodsMsg(this.scanningCode);
			},
			// 获取商品信息
			getGoodsMsg(code) {
				this.scanningCode=''
				code = (code).toString().trim();
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_member+'/api/GiftCard/single', {
					cardNumber:code
				}).then(res=>{
					loading.close()
					if(res.code===0){
						this.msg = res.data;
					}
				})
			},
			bind(){
				if(this.$public.isNull(this.msg.card_number)){
					this.$message({
						message: '请录入礼品卡号',
						type: 'error'
					});
					return
				}
				let memberId = this.userInfo._id;
				let memberName = this.userInfo.basic_info.nick_name;
				let memberMobile = this.userInfo.basic_info.user_mobile;
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_member+'/api/GiftCard/bind', {
					"card_number": this.msg.card_number,
					"user_id": memberId,
					"user_name": memberName,
					"user_mobile": memberMobile
				}).then(res=>{
					loading.close()
					if(res.code===0){
						this.$emit("submit",{type:'success'})
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				&.el-form--inline .el-form-item{
					margin:5px 0;margin-bottom:0;
					
				}
			}
		}
		.row{
			border-bottom:1px solid #F2F2F2;
			::v-deep .el-form-item__label{
				font-size: 12px;color:#999;
			}
			.value{
				font-size: 14px;color:#333;font-weight: bold;
			}
		}
		.tableTit{
			background-color: #FFF8F2;line-height: 44px;padding:0 20px;font-size: 14px;color:$fontColor;
		}
	}
	
</style>
